var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2326 2.69548C13.4278 1.49557 15.1761 1.47037 16.1441 2.44202C17.1138 3.41549 17.0876 5.17486 15.8916 6.37558L13.8717 8.40326C13.6281 8.64784 13.6289 9.04359 13.8734 9.28718C14.118 9.53076 14.5137 9.53001 14.7573 9.28543L16.7771 7.25775C18.3699 5.65883 18.5699 3.10605 17.0296 1.55984C15.4876 0.0118015 12.9405 0.213562 11.3469 1.81331L7.30721 5.86869C5.71447 7.46762 5.51451 10.0204 7.05473 11.5666C7.29833 11.8112 7.69406 11.8119 7.93865 11.5683C8.18315 11.3248 8.1839 10.929 7.94031 10.6844C6.97061 9.71101 6.99673 7.95159 8.19281 6.75086L12.2326 2.69548Z",
    fill: "#20435D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0687 7.39229C10.8251 7.14774 10.4294 7.14697 10.1848 7.39057C9.94029 7.63418 9.93954 8.02987 10.1831 8.27446C11.1529 9.24796 11.1267 11.0073 9.93063 12.208L5.89095 16.2635C4.69568 17.4634 2.94729 17.4885 1.97939 16.5169C1.00968 15.5435 1.03579 13.784 2.23188 12.5833L4.25174 10.5555C4.49535 10.311 4.49459 9.91529 4.25003 9.67171C4.00548 9.42812 3.60976 9.42887 3.36615 9.67337L1.34629 11.7011C-0.246467 13.3 -0.446433 15.8529 1.09379 17.399C2.63586 18.9471 5.18298 18.7454 6.77654 17.1456L10.8162 13.0902C12.409 11.4913 12.609 8.93854 11.0687 7.39229Z",
    fill: "#20435D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.71a17b941d240df6347a9a646b365a57.svg";
export { ForwardRef as ReactComponent };